import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MarkdownField } from "@/components/MarkdownField";

export const BriefItemEditor = ({ item, onSave, onCancel, testId }) => {
  const [form, setForm] = useState({
    instruction: item?.instruction || "",
    bare_acts: item?.bare_acts || "",
    judgments: item?.judgments || "",
  });

  return (
    <div className="border border-border rounded-sm p-4 space-y-3" data-testid={testId}>
      <div className="space-y-2">
        <Label className="label-caps">Instruction</Label>
        <MarkdownField
          value={form.instruction}
          onChange={(v) => setForm({ ...form, instruction: v })}
          testId={`${testId}-instruction`}
          minHeight={90}
          placeholder="e.g. Seek a short adjournment, the affidavit is not on record"
        />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="space-y-2">
          <Label className="label-caps">Bare Acts required</Label>
          <Input
            data-testid={`${testId}-bare-acts`}
            value={form.bare_acts}
            onChange={(e) => setForm({ ...form, bare_acts: e.target.value })}
            placeholder="e.g. Arbitration Act s. 34"
            className="rounded-sm h-11 text-base"
          />
        </div>
        <div className="space-y-2">
          <Label className="label-caps">Judgments required</Label>
          <Input
            data-testid={`${testId}-judgments`}
            value={form.judgments}
            onChange={(e) => setForm({ ...form, judgments: e.target.value })}
            placeholder="e.g. Vidya Drolia (2021) 2 SCC 1"
            className="rounded-sm h-11 text-base"
          />
        </div>
      </div>
      <div className="flex gap-2">
        <Button
          data-testid={`${testId}-save`}
          onClick={() => onSave(form)}
          className="rounded-full h-11 px-5"
        >
          Save instruction
        </Button>
        <Button
          variant="outline"
          data-testid={`${testId}-cancel`}
          onClick={onCancel}
          className="rounded-full h-11 px-5"
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};
